/**
 * Created by katarinababic on 23.6.25.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useState } from 'react';
import {
  HomeScreenSuggestionItemContent,
  HomeScreenSuggestionItemContentProps,
} from './HomeScreenSuggestionItemContent';
import { AlertModal } from '../../Components/AlertModal';
import { useRootStore } from '../../Store/useRootStore';
import { useTrans } from '../../Store/System/LocalizationStore';

export type HomeScreenSuggestionItemProps = HomeScreenSuggestionItemContentProps & {
  loading?: boolean;
  onboardingSection: 'generalInfo' | 'physicalHealth' | 'mentalHealth' | undefined;
  suggestionType: 'fitness' | 'mentalHealth' | 'recipe';
};

export const HomeScreenSuggestionItem: React.FC<HomeScreenSuggestionItemProps> = observer(
  ({ loading, onboardingSection, suggestionType, ...moreProps }) => {
    const { analytics } = useRootStore();
    const { t } = useTrans();

    const [showAlert, setShowAlert] = useState(false);

    const handleUnlock = React.useCallback(() => {
      setShowAlert(true);
      analytics.logEvent('unlockSuggestionClicked', { suggestionType });
    }, [analytics, suggestionType]);

    const handleHideUnlockAlert = React.useCallback(() => setShowAlert(false), []);

    return (
      <React.Fragment>
        <HomeScreenSuggestionItemContent {...moreProps} onUnlock={handleUnlock} />
        <AlertModal
          isOpen={showAlert}
          title={t('home.dailySuggestions.unlockContentTitle', { defaultValue: 'Complete Onboarding to Unlock' })}
          body={t('home.dailySuggestions.unlockContentBody', {
            defaultValue:
              'Please visit the KINASTIC mobile app and complete the onboarding questions in the relevant section to unlock this content.',
          })}
          cancelText="Close"
          confirmText="OK"
          onCancel={handleHideUnlockAlert}
          onConfirm={handleHideUnlockAlert}
        />
      </React.Fragment>
    );
  },
);
